export class YearOverYearComparison {
  latestValue: number;
  latestPercentage: number;
}
